import { Component, OnInit } from '@angular/core'
import { AuthenticationService } from '../../../_services/authentication.service'
import { RequestsService } from '../../../_shared/services/requests.service'
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms'
import { HelperFunctions } from '../../../_shared/utils/helper-functions'

declare var jQuery: any

@Component({
  selector: 'app-financial-literacy',
  templateUrl: './financial-literacy.component.html',
  styleUrls: ['./financial-literacy.component.scss'],
})
export class FinancialLiteracyComponent implements OnInit {
  addLiteracyForm: FormGroup
  editLiteracyForm: FormGroup

  constructor(
    private authenticationService: AuthenticationService,
    private requestService: RequestsService,
    private fb: FormBuilder,
    private helperFunctions: HelperFunctions
  ) {}

  countryName: string
  loading: boolean
  isLoadingContent: boolean
  isAddingContent: boolean
  isEditingContent: boolean
  isDeletingContent: boolean
  message: string
  literacyData: any
  literacyDataFilter: any
  page = 1
  count = 10
  searchItem: string
  singleLiteracyData: any
  status: string
  totalFiles: Array<File> = []
  totalFileNames = []
  contentId: string
  literacyTopic: string
  selectedLanguage: string
  isLoadingTopicDetails: boolean
  topicData: any
  topicImage: string
  topicDescription: string
  selectedFile: any = null
  isPublishing: boolean

  appendToFilename(filename, string) {
    let dotIndex = filename.lastIndexOf('.')
    if (dotIndex == -1) return filename + string
    else
      return (
        filename.substring(0, dotIndex) + string + filename.substring(dotIndex)
      )
  }

  changeFiles(event, index) {
    let time_stamp = new Date().getTime()
    if (<File>event.target.files && <File>event.target.files[0]) {
      if (index === 0 && typeof this.totalFiles[index] === 'undefined') {
        this.totalFiles.unshift(<File>event.target.files[0])
        this.totalFileNames.unshift(
          this.appendToFilename(
            <File>event.target.files[0].name,
            '_' + time_stamp
          )
        )
      } else {
        this.totalFiles[index] = <File>event.target.files[0]
        this.totalFileNames[index] = this.appendToFilename(
          <File>event.target.files[0].name,
          '_' + time_stamp
        )
      }
    }
  }

  changeImage(event) {
    this.selectedFile = <File>event.target.files[0]
  }

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
    ],
  }

  editorStyle = {
    height: '100px',
    marginBottom: '10px',
  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country
    this.literacyTopic = localStorage.getItem('literacy_topic')
    this.selectedLanguage = localStorage.getItem('selected_language')

    this.addLiteracyForm = this.fb.group({
      heading: ['', Validators.required],
      sub_heading: '',
      position: ['', Validators.required],
      description: '',
      photo_urls: this.fb.array([]),
    })

    this.editLiteracyForm = this.fb.group({
      heading: ['', Validators.required],
      sub_heading: '',
      position: ['', Validators.required],
      description: '',
      photo_urls: this.fb.array([]),
    })

    this.getSingleTopicDetails()
    this.loadFinancialLiteracyContent()
  }

  addLiteracyImages(): FormArray {
    return this.addLiteracyForm.get('photo_urls') as FormArray
  }

  editLiteracyImages(): FormArray {
    return this.editLiteracyForm.get('photo_urls') as FormArray
  }

  newImage(): FormGroup {
    return this.fb.group({
      image_url: '',
      position: '',
    })
  }

  addImage() {
    this.addLiteracyImages().push(this.newImage())
  }

  editImage() {
    this.editLiteracyImages().push(this.newImage())
  }

  removeAddImage(index) {
    this.addLiteracyImages().removeAt(index)
    this.totalFiles.splice(index)
    this.totalFileNames.splice(index)
  }

  removeEditImage(index) {
    this.editLiteracyImages().removeAt(index)
    this.totalFiles.splice(index)
    this.totalFileNames.splice(index)
  }

  openCity(evt, cityName) {
    // Declare all variables
    var i, tabcontent, tablinks

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName('tabcontent')
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none'
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName('tab-link')
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace('active', '')
    }

    // Show the current tab, and add an "active" class to the link that opened the tab
    document.getElementById(cityName).style.display = 'block'
    evt.currentTarget.className += ' active'
  }

  getSingleTopicDetails() {
    this.isLoadingTopicDetails = true
    this.requestService
      .dash_get(
        `financial/literacy/topic/update/${this.countryName}/${this.literacyTopic}`,
        null
      )
      .subscribe((res) => {
        this.isLoadingTopicDetails = false
        this.topicData = res.data
        this.topicImage = this.topicData.photo_url
        this.topicDescription = this.topicData.description
      })
  }

  updateLiteracyTopic(updateLiteracyTopicForm) {
    let formData = new FormData()

    this.loading = true
    formData.append('description', updateLiteracyTopicForm.description)
    if (this.selectedFile)
      formData.append('photo', this.selectedFile, this.selectedFile.name)

    this.requestService
      .dash_putWithImage(
        `financial/literacy/topic/update/${this.countryName}/${this.literacyTopic}`,
        formData
      )
      .subscribe(
        (response) => {
          this.loading = false
          if (response.success) {
            this.message = response.message
            this.status = 'success'
            this.getSingleTopicDetails()
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (!response.success) {
            this.status = 'error'
            this.message = response.message
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (error) => {
          this.loading = false
          this.status = 'error'
          this.message = 'Some error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  loadFinancialLiteracyContent() {
    this.isAddingContent ||
    this.isEditingContent ||
    this.isDeletingContent ||
    this.isPublishing
      ? (this.isLoadingContent = false)
      : (this.isLoadingContent = true)
    this.requestService
      .dash_get(
        `financial/literacy/${this.countryName}/${this.literacyTopic}/${this.selectedLanguage}`,
        null
      )
      .subscribe(
        (res) => {
          this.isLoadingContent = false
          let sortedData = []

          res.data
            ? (sortedData = res.data.sort(
                (a: any, b: any) => a.position - b.position
              ))
            : null
          this.literacyData = sortedData
          this.literacyDataFilter = sortedData
        },
        (err) => {
          this.isLoadingContent = false
          this.message = err.error
        }
      )
  }

  filterLiteracyContent(event) {
    this.searchItem = event.target.value
    this.literacyData
      ? (this.literacyDataFilter = this.literacyData.filter(
          (data) =>
            data.heading
              .toLowerCase()
              .indexOf(this.searchItem.toLowerCase()) !== -1
        ))
      : null
  }

  deleteContent(id: string): void {
    this.loading = true
    this.requestService
      .dash_delete(
        id,
        `financial/literacy/update/${this.countryName}/${this.literacyTopic}`
      )
      .subscribe(
        (res) => {
          this.loading = false
          this.status = 'success'
          this.isDeletingContent = true
          this.loadFinancialLiteracyContent()
          this.message = res.message
          this.helperFunctions.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isDeletingContent = false
            jQuery('#deleteLiteracyModal').modal('hide')
          })
        },
        (err) => {
          this.loading = false
          if (err.status === 404) {
            this.message = 'Financial literacy content not found!'
          } else {
            this.message = 'Some error occurred. Please try again'
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              this.isDeletingContent = false
              jQuery('deleteLiteracyModal').modal('hide')
            })
          }
        }
      )
  }

  addFinancialLiteracy() {
    this.loading = true
    const formData = new FormData()
    let literacyImages = []

    if (this.totalFiles && this.totalFiles.length > 0) {
      for (let j = 0; j < this.totalFiles.length; j++) {
        this.totalFiles[j] && this.totalFileNames[j]
          ? formData.append(
              'files[]',
              this.totalFiles[j],
              this.totalFileNames[j]
            )
          : null
      }
    }

    this.addLiteracyForm.value.photo_urls.forEach((element, index) => {
      let imageUrl = this.totalFileNames[index]
        ? '/images/' + this.totalFileNames[index].replace(/ /g, '')
        : ''

      let imageObject = {
        image_url: imageUrl,
        position: element.position,
      }

      literacyImages.push(imageObject)
    })

    formData.append('topic', this.literacyTopic)
    formData.append('heading', this.addLiteracyForm.value.heading)
    formData.append('sub_heading', this.addLiteracyForm.value.sub_heading)
    formData.append('position', this.addLiteracyForm.value.position)
    formData.append('description', this.addLiteracyForm.value.description)
    formData.append('photo_urls', JSON.stringify(literacyImages))

    this.requestService
      .dash_putWithImage(
        `financial/literacy/${this.countryName}/${this.literacyTopic}/${this.selectedLanguage}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAddingContent = true
            this.loadFinancialLiteracyContent()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeAddModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeAddModal() {
    jQuery(document).ready(() => {
      this.isAddingContent = false
      jQuery('#addLiteracyContentModal').modal('hide')
      this.addLiteracyImages().controls = []
      this.addLiteracyForm.reset()
      this.resetFiles()
    })
  }

  resetFiles() {
    this.totalFiles = []
    this.totalFileNames = []
  }

  setSingleContentViewData(data: object) {
    this.singleLiteracyData = data
    this.contentId = this.singleLiteracyData.id

    this.editLiteracyForm.patchValue({
      heading: this.singleLiteracyData.heading,
      sub_heading: this.singleLiteracyData.sub_heading,
      position: this.singleLiteracyData.position,
      description: this.singleLiteracyData.description,
    })
    let sortedImages = []

    this.singleLiteracyData.photo_urls
      ? (sortedImages = this.singleLiteracyData.photo_urls.sort(
          (a: any, b: any) => a.position - b.position
        ))
      : null
    this.editLiteracyForm.setControl(
      'photo_urls',
      this.setExistingImages(sortedImages)
    )
  }

  setExistingImages(existingImages): FormArray {
    const formArray = new FormArray([])
    existingImages
      ? existingImages.forEach((element) => {
          formArray.push(
            this.fb.group({
              image_url: element.image_url,
              position: element.position,
            })
          )
        })
      : null
    return formArray
  }

  editFinancialLiteracy() {
    this.loading = true
    let formData = new FormData()

    let literacyImages = []

    if (this.totalFiles && this.totalFiles.length > 0) {
      for (let j = 0; j < this.totalFiles.length; j++) {
        this.totalFiles[j] && this.totalFileNames[j]
          ? formData.append(
              'files[]',
              this.totalFiles[j],
              this.totalFileNames[j]
            )
          : null
      }
    }

    this.editLiteracyForm.value.photo_urls.forEach((element, index) => {
      let imageUrl = this.totalFileNames[index]
        ? '/images/' + this.totalFileNames[index].replace(/ /g, '')
        : element.image_url

      let imageObject = {
        image_url: imageUrl,
        position: element.position,
      }
      literacyImages.push(imageObject)
    })

    formData.append('heading', this.editLiteracyForm.value.heading)
    formData.append('sub_heading', this.editLiteracyForm.value.sub_heading)
    formData.append('description', this.editLiteracyForm.value.description)
    formData.append('position', this.editLiteracyForm.value.position)
    formData.append('photo_urls', JSON.stringify(literacyImages))

    this.requestService
      .dash_putWithImage(
        `financial/literacy/update/${this.countryName}/${this.literacyTopic}/${this.contentId}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success) {
            this.message = res.message
            this.status = 'success'
            this.isEditingContent = true
            this.loadFinancialLiteracyContent()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeEditModal()
          } else if (!res.success) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (error) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeEditModal() {
    jQuery(document).ready(() => {
      this.isEditingContent = false
      jQuery('#editLiteracyContentModal').modal('hide')
      this.editLiteracyImages().controls = []
      this.editLiteracyForm.reset()
      this.resetFiles()
    })
  }

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#addLiteracyContentModal').on('hidden.bs.modal', () => {
        this.closeAddModal()
      })
      jQuery('#editLiteracyContentModal').on('hidden.bs.modal', () => {
        this.closeEditModal()
      })
    })
  }

  checkPublishStatus(status: string, content) {
    return status === content.status
  }

  publishContent(id: string) {
    this.loading = true

    this.requestService.dash_put(`publish_or_unpublish/${id}`, null).subscribe(
      (res) => {
        this.loading = false
        if (res.success === true) {
          this.status = 'success'
          this.isPublishing = true
          this.message = res.message
          this.helperFunctions.displayAlert(this.message, this.status)
          this.loadFinancialLiteracyContent()
          jQuery(document).ready(() => {
            this.isPublishing = false
            jQuery('#publishContent').modal('hide')
          })
        } else if ((res.success = false)) {
          this.status = 'error'
          this.message = res.message
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      },
      (err) => {
        this.loading = false
        if (err.status === 404) {
          this.message = 'Content not found!'
        } else {
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunctions.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isPublishing = false
            jQuery('#publishContent').modal('hide')
          })
        }
      }
    )
  }
}
